import classnames from 'classnames';
import React from 'react';

import { IconButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import { Menu } from '@eika/menu';

import HeaderAttentionMessage from './HeaderAttentionMessage';
import { HeaderProps } from './HeaderTypes';
import Logo from './Logo';

const NativeHeader: React.FC<HeaderProps> = ({
    showAttentionMessage,
    attentionMessage,
    frontpage,
    scrolled,
    scrollToTop,
    onKeyDown,
    logout,
    onMenuOpen,
    logo,
    pageName,
    logoutButtonText,
    bankLink,
    alwaysMenu,
    menuItems,
    nativeMenuItems,
    children,
}) => {
    return (
        <div
            className={classnames('sgw-header', {
                'not-frontpage': !frontpage,
                frontpage,
                'sgw-header--attention-message': showAttentionMessage,
            })}
        >
            <div className="sgw-header__inner native-header">
                <header
                    className={classnames('header', { 'header--narrow': scrolled })}
                    onClick={scrollToTop}
                    onKeyDown={onKeyDown}
                >
                    {logo && <Logo logo={logo} />}
                    {!frontpage && (
                        <>
                            <IconButton
                                type="button"
                                onClick={() => window.history.back()}
                                screenReaderText="Tilbake"
                                icon={IconTypes.BACK}
                                className="header__back-button"
                            />
                        </>
                    )}

                    {/* SPACE FOR APPS */}
                    {children}

                    {!frontpage && pageName ? (
                        <h1 className={classnames('header__page-name', { 'header__page-name--narrow': scrolled })}>
                            {pageName}
                        </h1>
                    ) : (
                        <h1 className="header__page-name-hidden">Forside</h1>
                    )}

                    {alwaysMenu && !frontpage && (
                        <Menu
                            items={menuItems}
                            nativeItems={nativeMenuItems}
                            onMenuOpen={onMenuOpen}
                            isNative
                            logout={logout}
                            logoutButtonText={logoutButtonText}
                            bankLink={bankLink}
                        />
                    )}
                    {frontpage && (
                        <Menu
                            items={menuItems}
                            nativeItems={nativeMenuItems}
                            onMenuOpen={onMenuOpen}
                            isNative
                            bankLink={bankLink}
                            logout={logout}
                            logoutButtonText={logoutButtonText}
                        />
                    )}
                </header>
            </div>
            {showAttentionMessage && attentionMessage ? (
                <HeaderAttentionMessage
                    id={attentionMessage.id}
                    message={attentionMessage.message}
                    type={attentionMessage.type}
                    link={attentionMessage.link}
                    isNative
                />
            ) : (
                <div className="sgw-header-background" />
            )}
        </div>
    );
};

export default NativeHeader;
